(() => {
  'use strict';
  const header = document.querySelector('[data-vt-header]');
  if (!header) return;
  const toggle = header.querySelector('.vs-menu-toggle');
  const nav = header.querySelector('.vs-nav');
  const groups = [...header.querySelectorAll('.vt-nav-group')];
  const closeGroups = except => groups.forEach(group => { if (group !== except) group.open = false; });
  function closeNavigation(restoreFocus = false) {
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open navigation');
    nav.classList.remove('is-open');
    closeGroups();
    if (restoreFocus && wasOpen) toggle.focus();
  }
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    nav.classList.toggle('is-open', open);
    if (!open) closeGroups();
  });
  groups.forEach(group => group.addEventListener('toggle', () => { if (group.open) closeGroups(group); }));
  nav.addEventListener('click', event => { if (event.target.closest('a')) closeNavigation(); });
  document.addEventListener('click', event => { if (!header.contains(event.target)) closeNavigation(); });
  document.addEventListener('focusin', event => { if (!header.contains(event.target)) closeNavigation(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openGroup = groups.find(group => group.open);
    if (openGroup) {
      closeGroups();
      if (openGroup.contains(document.activeElement)) openGroup.querySelector('summary').focus();
    } else closeNavigation(true);
  });
  window.matchMedia('(max-width: 1000px)').addEventListener('change', () => closeNavigation());
})();
